/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { PageInfoFragmentDoc } from '../pageInfo/pageInfo.g';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ResourceCategoryFragment = { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null };

export type ResourceCategoriesQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  name_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  parent_Isnull?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ResourceCategoriesQuery = { __typename: 'Query', resourceCategories?: { __typename: 'ResourceCategoryTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ResourceCategoryTypeEdge', node?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const ResourceCategoryFragmentDoc = `
    fragment ResourceCategory on ResourceCategoryType {
  id
  name
  parent {
    id
    name
  }
}
    `;
export const ResourceCategoriesDocument = `
    query ResourceCategories($after: String, $first: Int, $before: String, $last: Int, $offset: Int, $name_Icontains: String, $parent_Isnull: Boolean) {
  resourceCategories(
    after: $after
    first: $first
    before: $before
    last: $last
    offset: $offset
    name_Icontains: $name_Icontains
    parent_Isnull: $parent_Isnull
  ) {
    edges {
      node {
        ...ResourceCategory
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    ${ResourceCategoryFragmentDoc}
${PageInfoFragmentDoc}`;

export const useResourceCategoriesQuery = <
      TData = ResourceCategoriesQuery,
      TError = unknown
    >(
      variables?: ResourceCategoriesQueryVariables,
      options?: Omit<UseQueryOptions<ResourceCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ResourceCategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ResourceCategoriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ResourceCategories'] : ['ResourceCategories', variables],
    queryFn: fetcher<ResourceCategoriesQuery, ResourceCategoriesQueryVariables>(ResourceCategoriesDocument, variables),
    ...options
  }
    )};

useResourceCategoriesQuery.getKey = (variables?: ResourceCategoriesQueryVariables) => variables === undefined ? ['ResourceCategories'] : ['ResourceCategories', variables];

export const useInfiniteResourceCategoriesQuery = <
      TData = InfiniteData<ResourceCategoriesQuery>,
      TError = unknown
    >(
      variables: ResourceCategoriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ResourceCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ResourceCategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ResourceCategoriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ResourceCategories.infinite'] : ['ResourceCategories.infinite', variables],
      queryFn: (metaData) => fetcher<ResourceCategoriesQuery, ResourceCategoriesQueryVariables>(ResourceCategoriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteResourceCategoriesQuery.getKey = (variables?: ResourceCategoriesQueryVariables) => variables === undefined ? ['ResourceCategories.infinite'] : ['ResourceCategories.infinite', variables];


useResourceCategoriesQuery.fetcher = (variables?: ResourceCategoriesQueryVariables) => fetcher<ResourceCategoriesQuery, ResourceCategoriesQueryVariables>(ResourceCategoriesDocument, variables);
